import { render, staticRenderFns } from "./resource_list.vue?vue&type=template&id=3f924364&scoped=true"
import script from "./resource_list.vue?vue&type=script&lang=js"
export * from "./resource_list.vue?vue&type=script&lang=js"
import style0 from "./resource_list.vue?vue&type=style&index=0&id=3f924364&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f924364",
  null
  
)

export default component.exports